package app.nestbridge.feature.invitations.usecase

import app.nestbridge.feature.invitations.model.Invitation
import app.nestbridge.feature.invitations.service.InvitationService
import me.tatarka.inject.annotations.Inject

@Inject
class FindInvitationByClaimTokenUseCase(
    private val invitationService: InvitationService,
) {
    suspend operator fun invoke(token: String): Result<Invitation?> =
        invitationService.findByClaimToken(token)
}
